import request from '@/utils/request'
import store from '@/store'

export function login(data) {
  return request({
    url: '/login',
    method: 'get',
    params: data
  })
}
export function reguser(data) {
  return request({
    url: '/reguser',
    method: 'get',
    params: data
  })
}
export function getInfo(data) {
  return request({
    url: '/getuserinfo',
    method: 'get',
    params: data
  })
}
export async function getAccount(data) {
    return await request({
        url: '/getaccount',
        method: 'get',
        params: data
    })
}
export async function saveAccounts(data) {
    return await request({
        url: '/saveaccounts',
        method: 'put',
        data: data
    })
}
export async function deleteAccount(data) {
    return await request({
        url: '/deleteaccount',
        method: 'get',
        params: data
    })
}
export function logout() {
  return request({
    url: '/logout',
    method: 'get',
    params: { username: store.getters.username }
  })
}
export function saveAvatar(data) {
  return request({
    url: '/saveavatar',
    method: 'get',
    params: data
  })
}
export async function modifypassword(accountid, oldpassword, newpassword) {
    return request({
        url: '/modifypassword',
        method: 'get',
        params: {
            accountid: accountid,
            oldpassword: oldpassword,
            newpassword: newpassword
        }
    })
}
